import type { ReactElement } from 'react';

import { Component as NextIcon } from 'icons/icon-ui--arrow-right-outline.svg';
import { Component as PrevIcon } from 'icons/icon-ui--arrow-left-outline.svg';

type Props = {
  direction: 'next' | 'prev';
  disabled: boolean;
  onClick: () => void;
};

function ScrollButton({
  direction,
  disabled,
  onClick,
}: Props): ReactElement {
  return (
    <div
      className={[
        `c-recipe-gallery__${direction}`,
        disabled ? 'is-disabled' : '',
      ].join(' ')}
      aria-hidden="true"
      onClick={onClick}
    >
      {direction === 'next' ? <NextIcon /> : <PrevIcon />}
    </div>
  );
}

export default ScrollButton;
